import React from 'react';
import { useReframe } from 'nike-re-framejs';
import LiveMatchFacade from '@/scoreboards/services/liveMatchFacade';
import i18n from '@i18n';

export function BreakStatus({ event }) {
    const status = event && event.get('eventStatus');
    const isBreak = status && LiveMatchFacade.isBreak(status.get('code'));
    const showStatuses = showStatusesForEvent(event);

    return showStatuses && isBreak ? (
        <span key="BreakStatus">{i18n('jsp.liveStavky.detailPodujatia.message.BREAK')}</span>
    ) : null;
}

export function FinishedStatus({ event }) {
    const status = event && event.get('eventStatus');
    const isFinished = status && LiveMatchFacade.isFinished(status);
    const finishedMessage = status && status.get('message');

    return isFinished && finishedMessage ? <span key="FinishStatus">{finishedMessage}</span> : null;
}

export function TieBreakStatus({ event }) {
    const tieBreak = event && event.get('tieBreakMsg');
    return tieBreak ? <span key="TieBreak">{tieBreak}</span> : null;
}

export function TimeMMSSStatus({ event, clock }) {
    const showStatuses = showStatusesForEvent(event);
    return showStatuses ? <TimeMMSSStatusDeref eventId={event.get('id')} subsPrefix={clock} /> : null;
}
function TimeMMSSStatusDeref({ eventId, subsPrefix }) {
    const derefSub = useReframe();
    const clock = derefSub([subsPrefix + '.clock', eventId]);
    const mmss = clock && clock.getIn(['mmss'], '');
    return mmss ? (
        <span key="TimeMMSSStatus" className="minutes">
            {mmss}
        </span>
    ) : null;
}

export function TimeMMStatus({ event, clock }) {
    const showStatuses = showStatusesForEvent(event);
    return showStatuses ? <TimeMMStatusDeref eventId={event.get('id')} subsPrefix={clock} /> : null;
}

function TimeMMStatusDeref({ eventId, subsPrefix }) {
    const derefSub = useReframe();
    const mm = derefSub([subsPrefix + '.clock.mm', eventId]) || '';
    return (
        <span key="TimeMMStatus" className="minutes">
            {mm}
        </span>
    );
}

export function CurrentPeriodStatus({ event }) {
    const activePeriodName = event && event.getIn(['currentPeriod', 'name']);
    const showStatuses = showStatusesForEvent(event);
    const status = event && event.get('eventStatus');
    const isBreak = status && LiveMatchFacade.isBreak(status.get('code'));
    const isTieBreak = !!event.get('tieBreakMsg');

    return showStatuses && !isBreak && !isTieBreak ? (
        <span key="CurrentPeriodStatus" className="period">
            {activePeriodName}
        </span>
    ) : null;
}

export function BestOfStatus({ event }) {
    const bestOf = event && event.get('bestOf');
    const dartsMatchType = event && event.get('dartsMatchType');
    const showStatuses = showStatusesForEvent(event);

    return bestOf && showStatuses ? (
        <span key="BestOfStatus" className="darts-best-of">
            (best of {bestOf + (dartsMatchType === 'LEGS' ? ' legs' : ' sets')})
        </span>
    ) : null;
}

export function NoAdvantageStatus({ event }) {
    const noAdvantage = event && event.get('noAdvantage');
    const showStatuses = showStatusesForEvent(event);

    return noAdvantage && showStatuses ? (
        <span key="NoAdvantageStatus">{i18n('jsp.liveStavky.event.tenis.noAdvantage')}</span>
    ) : null;
}

export function NonStandardHalftimeStatus({ event }) {
    const nonStandardHalftimeInMinutes = event && event.get('nonStandardHalftimeInMinutes');
    const showStatuses = showStatusesForEvent(event);

    return nonStandardHalftimeInMinutes && showStatuses ? (
        <span key="NonStandardHalftimeStatus" className="halftime-length">
            {i18n('jsp.liveStavky.detailPodujatia.halftimeLength') + ' ' + nonStandardHalftimeInMinutes}
        </span>
    ) : null;
}

export function RaindelayStatus({ event }) {
    const extraInfo = event && event.get('extraInfo');

    return extraInfo && LiveMatchFacade.isRainDelay(extraInfo) ? (
        <span key="RaindelayStatus">{i18n('jsp.liveStavky.detailPodujatia.message.RAIN-DELAY')}</span>
    ) : null;
}

export function showStatusesForEvent(event) {
    const extraInfo = event.get('extraInfo');
    const eventStatus = event && event.get('eventStatus');
    const eventStatusCode = eventStatus && eventStatus.get('code');
    const isFinished = LiveMatchFacade.isFinished(eventStatusCode || eventStatus);

    const isInterupted = LiveMatchFacade.isInterrupted(eventStatusCode);
    const isRainDelay = LiveMatchFacade.isRainDelay(extraInfo);

    return !(isFinished || isInterupted || isRainDelay);
}
